import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 5v3.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.5A.75.75 0 1 0 8 10a.75.75 0 0 0 0 1.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgWarning;
